// extracted by mini-css-extract-plugin
export var compact = "_mk-2";
export var phoneFrame = "_mk-0";
export var phoneScreen = "_mk-1";